import React from 'react';
import { StyledColoredTooltip } from '../Styled';

interface IColoredTooltip {
  content: string;
  background: string;
  containerStyle?: React.CSSProperties;
  children: JSX.Element;
}

export const ColoredTooltip = (props: IColoredTooltip): JSX.Element => {
  const { background, content, containerStyle, children } = props;

  return (
    <StyledColoredTooltip
      containerStyle={containerStyle}
      tooltipStyle={{ background: background }}
      content={content}
      background={background}
    >
      {children}
    </StyledColoredTooltip>
  );
};
